import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, UrlTree, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { awsConfig } from '../../config_cognito';

@Injectable({
  providedIn: 'root'
})
export class AccessGuard implements CanActivate {
  // se activa cuando el usuario obtiene el token sino no permite ingresar a una url(portal/entregas) no autentificado
  constructor(private _router: Router) { }

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const userPoolWebClientId = awsConfig.Auth.userPoolWebClientId;
    const email = localStorage.getItem(`CognitoIdentityServiceProvider.${userPoolWebClientId}.LastAuthUser`);
    // const token = localStorage.getItem(`CognitoIdentityServiceProvider.${userPoolWebClientId}.${email}.idToken`);
    // const refreshToken = localStorage.getItem(`CognitoIdentityServiceProvider.${userPoolWebClientId}.${email}.refreshToken`);

    const getCookieValue = (name) => (
      document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
    )
    let token, refreshToken = null
    token = getCookieValue('idToken');
    refreshToken = getCookieValue('refreshToken')

    if (!!token ) {
      this._router.navigate(['portal']);
    }
    return true;
  }
};